/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import SimpleInput from '/client/src/components/forms/simpleInput';
import DataTable from 'react-data-table-component';
import { emailRegexp } from '/client/src/constants';
import './styles.scss';

type PropsType = {
  isOpen: boolean,
  isPending: boolean,
  handleClose: () => void,
  handleCreateSponsor: () => void,
  getGlobalSponsors: () => void,
  isPendingGlobalSponsors: boolean,
  handleAddSponsor: () => void,
  sponsorsGlobal: []
};

const ModalCreateSponsor = (
  {
    isOpen,
    isPending,
    handleClose,
    handleCreateSponsor,
    getGlobalSponsors,
    isPendingGlobalSponsors,
    handleAddSponsor,
    sponsorsGlobal
  }: PropsType
): React.Element<'div'> => {
  const [popupStep, setPopupStep] = React.useState('add');
  const [popupPrevStep, setPopupPrevStep] = React.useState(null);

  const changeStep = (newStep: string, prevSten: string = popupStep) => {
    setPopupPrevStep(prevSten);
    setPopupStep(newStep);
  };

  // const AddOrCreate = (): void => (
  //   <>
  //     <div className="modal-body EventPageDetailSponsor-addButton-container">
  //       <button
  //         className="EventPageDetailSponsor-addButton"
  //         type="button"
  //         onClick={(): void => {
  //           getGlobalSponsors();
  //           changeStep('add');
  //         }}
  //       >Add Sponsors</button>
  //       <button
  //         className="EventPageDetailSponsor-addButton"
  //         type="button"
  //         onClick={(): void => changeStep('create')}
  //       >Create New Sponsor</button>
  //     </div>
  //     <div className="modal-footer">
  //       <button className="btn btn-gray" onClick={handleClose}>Cancel</button>
  //     </div>
  //   </>
  // );

  // const Create = (): void => {
  //   const [sponsorName, setSponsorName] = React.useState('');
  //   const [sponsorEmail, setSponsorEmail] = React.useState('');
  //   const [isEditEmail, setEditEmail] = React.useState(false);
  //   const [isValidEmail, setValidEmail] = React.useState(false);
  //   const [isChangedName, setIsChangedName] = React.useState(false);
  //
  //   return (
  //     <>
  //       <div className="modal-body container-fluid modal-sponsor-create">
  //         <form className="row">
  //           <div className="col-md-6">
  //             <SimpleInput
  //               label='Sponsor Name'
  //               name='sponsorName'
  //               id='sponsorName'
  //               value={sponsorName}
  //               onChange={(e: any) => {
  //                 setIsChangedName(true);
  //                 setSponsorName(e.target.value);
  //               }}
  //               validator={isChangedName ? {
  //                 text: <i className='glyphicon glyphicon-warning-sign' />
  //               } : false}
  //             />
  //           </div>
  //           <div className="col-md-6">
  //             <SimpleInput
  //               label='Sponsor Email'
  //               name='sponsorEmail'
  //               id='sponsorEmail'
  //               value={sponsorEmail}
  //               onChange={(e: any) => {
  //                 const valid = emailRegexp.test(e.target.value);
  //
  //                 setSponsorEmail(e.target.value);
  //                 setEditEmail(true);
  //                 setValidEmail(valid);
  //               }}
  //             />
  //           </div>
  //         </form>
  //       </div>
  //       <div className="modal-footer">
  //         <button
  //           className="btn btn-gray"
  //           onClick={handleClose}
  //           style={{ borderColor: 'transparent' }}
  //         >Cancel</button>
  //         <button
  //           className="btn btn-gray"
  //           onClick={(): void => changeStep(popupPrevStep, null)}
  //         >Back</button>
  //         <button
  //           className={`btn btn-pink actionBtn
  //           ${!isPending && isEditEmail && isValidEmail && isChangedName ? '' : 'is-disabled'}`
  //           }
  //           onClick={(): void => handleCreateSponsor([sponsorEmail], sponsorName)}
  //         >Create</button>
  //       </div>
  //     </>
  //   );
  // };

  const Add = (): void => {
    const columns = [
      {
        selector: 'name',
        name: 'Sponsor name',
        sortable: true
      }
    ];
    const customStyles = {
      headCells: {
        style: {
          fontWeight: 700,
          fontSize: '1rem'
        }
      },
      table: {
        style: {
          maxHeight: '40vh'
        }
      }
    };

    const [selectedRows, handleSelectRow] = React.useState([]);

    return (
      <>
        <div className="modal-body container-fluid modal-sponsor-create">
          {!isPendingGlobalSponsors ?
            <form className="row">
              <DataTable
                columns={columns}
                data={sponsorsGlobal}
                customStyles={customStyles}
                selectableRows // add for checkbox selection
                Clicked
                onSelectedRowsChange={(selected: any): void => handleSelectRow(selected.selectedRows)}
                selectableRowsHighlight
                pagination={!!_.size(sponsorsGlobal) > 10}
                highlightOnHover
                responsive
                striped
                fixedHeader
                noHeader
                sortIcon={(): React.Element<typeof React.Fragment> => {
                  return (
                    <>
                      <span className="-sort-desc" />
                      <span className="-sort-asc" />
                    </>
                  );
                }}
              />
            </form>
            :
            <div>
              <div className='csspinner' style={{ width: '50px', height: '50px', margin: '0 auto' }} />
            </div>
          }
        </div>
        <div className="modal-footer">
          <button
            className="btn btn-gray"
            onClick={handleClose}
            style={{ borderColor: 'transparent' }}
          >Cancel
          </button>
          <button
            className={`btn btn-pink actionBtn
            ${!isPending && !!_.size(selectedRows) ? '' : 'is-disabled'}`
            }
            onClick={(): void => handleAddSponsor(selectedRows)}
          >Add
          </button>
        </div>
      </>
    );
  };

  return (
    <Modal
      overflow='visible'
      opened={isOpen}
      onClose={handleClose}
      altView
      isScrollable
    >
      <div className={`
            modal-dialog
            customModal
            EventPageSponsorModal
            modal-table-filter
          `} role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            {/* {popupStep === 'addOrCreate' &&*/}
            {/*  <div>*/}
            {/*    <h4 className="modal-title"><span>Select action</span></h4>*/}
            {/*    <span className="modal-subtitle">*/}
            {/*        Choose to add sponsors from global sponsor list or create a new sponsor.*/}
            {/*    </span>*/}
            {/*  </div>*/}
            {/* }*/}
            {popupStep === 'add' &&
              <div>
                <h4 className="modal-title"><span>Add sponsors</span></h4>
                <span className="modal-subtitle">
                  Select the sponsors to add then click add.
                </span>
              </div>
            }
            {/* {popupStep === 'create' &&*/}
            {/*  <div>*/}
            {/*    <h4 className="modal-title"><span>Create sponsor</span></h4>*/}
            {/*    <span className="modal-subtitle">*/}
            {/*      Create a new sponsor.*/}
            {/*    </span>*/}
            {/*  </div>*/}
            {/* }*/}
          </div>

          {/* {popupStep === 'addOrCreate' && <AddOrCreate />}*/}
          {/* {popupStep === 'create' && <Create />}*/}
          {popupStep === 'add' && <Add />}
        </div>
      </div>
    </Modal>
  );
};

export default ModalCreateSponsor;
